import React, { useState } from 'react';
import './App.css';
import {UserProvider} from "./context/UserContext";
import { BrowserRouter as Router} from 'react-router-dom';
import NavigationComponent from "./navigation/NavigationComponent";

function App() {
  const [showSignIn, setShowSignIn] = useState(false);

  return (
      <Router>
          <UserProvider>
              <NavigationComponent showSignIn={showSignIn}
                                   setShowSignIn={setShowSignIn}/>
          </UserProvider>
      </Router>
  );
}

export default App;
